import React from 'react'

import useCloseOnClickOutside from '../hooks/use-close-on-click-outside'
import bem from '../utils/bem'
import {useAlignOnScroll} from './popup-menu'
import {Options} from './popup-select'
import {useOptions} from './producer-select'


// A standalone producer picker: portals a search input + result list anchored to
// `anchorRef`, with no inline trigger of its own. Mount it to show the popup,
// unmount to hide. Calls onSelect(producerId) on pick, onClose() on dismiss.
export default function ProducerSearchPopup({anchorRef, onSelect, onClose, initialQuery}) {
    const className = bem('popup-select')
    const sref = React.useRef()
    const iref = React.useRef()
    const [query, setQuery] = React.useState(initialQuery || '')
    const options = useOptions(query)
    const {setToAlign} = useAlignOnScroll(anchorRef.current)

    useCloseOnClickOutside(true, onClose, sref, anchorRef)

    // Focus and select the pre-filled name so the user can keep or replace it.
    // Deferred so it wins over the More menu re-focusing its trigger on close.
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (iref.current) {
                iref.current.focus()
                iref.current.select()
            }
        }, 0)
        return () => clearTimeout(timeout)
    }, [])

    return <Options
        options={options}
        className={className}
        parentRef={anchorRef}
        sref={sref}
        iref={iref}
        setToAlign={setToAlign}
        query={query}
        setQuery={setQuery}
        setOpen={() => {}}
        onUpdate={value => onSelect(value)}
    />
}
